// src/utils/TikTokTracking.js
import axios from "axios";
import CryptoJS from "crypto-js";

// TikTok config (use env vars in production)
const TIKTOK_ACCESS_TOKEN = "4891103d4a2f0179c87155897ef6840a248a82c7"; // Your access token
const TIKTOK_PIXEL_ID = "D5OJOFRC77U96LODPCRG"; // e.g., "D3N2MN3C77U1N95DVHHG"
// const TIKTOK_ENDPOINT = 'https://business-api.tiktok.com/open_api/v1.3/event/track/';
const TIKTOK_ENDPOINT = "tiktokEvents";

// Function to hash data with SHA-256
export const hashData = (data) => {
  if (!data) return "";
  return CryptoJS.SHA256(data.toLowerCase()).toString(CryptoJS.enc.Hex);
};

export const sendTikTokEvent = async ({
  pixelId = TIKTOK_PIXEL_ID,
  accessToken = TIKTOK_ACCESS_TOKEN,
  baseUrl = "https://dodeal.dodealcrm.com/api/",
  endpoint = TIKTOK_ENDPOINT,
  eventName,
  phone,
  ttclid,
  url = window.location.href,
  testEventcode,
}) => {
  try {
    const payload = {
      pixel_id: pixelId,
      access_token: accessToken,
      event: eventName,
      phone,
      url,
      ttclid,
      test_event_code: testEventcode,
    };
    const response = await axios.post(`${baseUrl}${endpoint}`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.json();
  } catch (error) {
    console.error("Error sending TikTok event:", error);
    return { success: false, error };
  }
};
